import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {Role} from "../../../roles/Role";
import {SchedulePagePrivate} from "../../../../../pages/Lk/OperatorsOnly/Schedule/SchedulePagePrivate";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const SchedulePrivateRouteTitleMessage = defineMessage({
  id: "schedulePrivateRoute.title",
  defaultMessage: "Private Schedule",
})

export const schedulePrivate: RouteDescriptor<Route.schedulePrivate> = {
  route: Route.schedulePrivate,
  render: SchedulePagePrivate,
  title: SchedulePrivateRouteTitleMessage,
  path: '/lk/schedule-private',
  allowRoles: [
    Role.freighterAdmin,
    Role.freighterServiceManager,
    Role.freighterClientManager,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
  group: PageGroups.FLEET,
  groupTitle: PageGroupMessages.fleet,
}

